import React from "react";
import { Header, Footer, ReferenceLogos } from "../containers";
import { MetaTags } from "../components";
import {
  Breadcrumbs,
  Sidebar,
  PageTitle,
  InfoContent,
} from "../components/User";

const UserLayout = ({ title, content, children }) => {
  return (
    <>
      <MetaTags title={title} />
      <Header isTransparent={false} />
      <Breadcrumbs />
      <br />
      <br />
      <br />
      <div className="container-fluid">
        <div className="container userpanel__container">
          <div className="row">
            <div className="col-3 user__sidebar">
              <Sidebar />
            </div>
            <div className="col-8">
              <div className="user__page_content">
                <PageTitle title={title} />
                <InfoContent content={content} />
                <div className="user__page__content_inner mt-2">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br /> <br />
      <br />
      <ReferenceLogos />
      <Footer />
    </>
  );
};

export default UserLayout;
